import { Component } from 'react'

class SignupEvent extends Component {}

export default SignupEvent
